/**
 * @generated SignedSource<<ca5697fbb6a29ad933542b5ec3a3de2d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4Filters$data = {
  readonly jira: {
    readonly hasIsFiltersExpanded?: "JiraQuery";
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4FiltersForLanding">;
  readonly " $fragmentType": "Nav4Filters";
};
export type Nav4Filters$key = {
  readonly " $data"?: Nav4Filters$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4Filters">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isFiltersExpanded"
    }
  ],
  "kind": "Fragment",
  "name": "Nav4Filters",
  "selections": [
    {
      "condition": "isFiltersExpanded",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "Nav4FiltersForLanding"
        }
      ]
    },
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "condition": "isFiltersExpanded",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": "hasIsFiltersExpanded",
              "kind": "ScalarField",
              "name": "__typename"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "3df2d83f4108ed18026f86044ce6e248";

export default node;
